"use strict";
/**
 * validateRoutingNum function for validating the routing number
 *
 * @param input - string
 * @returns string - whether the routing number is valid or not
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRoutingNum = void 0;
const validateRoutingNum = (input) => {
    const val = input.match(/\d/g);
    let result = "";
    if (val) {
        result = val.join("").substring(0, 9);
    }
    if (result.length < 9) {
        return "Routing number should have 9 digits.";
    }
    return "";
};
exports.validateRoutingNum = validateRoutingNum;
